import { supabase } from '@/lib/supabase';
import { GetLLMApiBillingParams } from './type';

export const getLLMApiBilling = async (params: GetLLMApiBillingParams) => {
  const { data, error } = await supabase
    .from('llm_api_billing_history')
    .select()
    .lte('billing_at', params.billingAt.endDate)
    .gte('billing_at', params.billingAt.startDate)
    .order('billing_at', { ascending: false });
  if (error) throw error;
  return data;
};
